import React, { useState } from "react";
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import { Settings } from "@mui/icons-material";
import LanguagePicker from "../Translate/LanguagePicker";
import { useTranslate } from "../Translate/TranslateContext";
import PasswordSettings from "./PasswordSettings";
import DeviceSettings from "./DeviceSettings";
import { buttonPrimaryStyles } from "../../styles/ComponentStyles";

export default function OptionsModal({ user, onLogout }) {
  const { translate } = useTranslate();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("main");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setView("main");
    setOpen(false);
  };

  return (
    <>
      <IconButton color="primary" onClick={handleOpen}>
        <Settings />
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            width: 360,
            p: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {view === "main" && (
            <>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {translate("settings")}
              </Typography>

              <Divider />

              <Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {translate("language")}
                </Typography>
                <LanguagePicker />
              </Box>

              <Divider />

              <Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {translate("password")}
                </Typography>
                <Button
                  variant="outlined"
                  sx={buttonPrimaryStyles}
                  onClick={() => setView("password")}
                >
                  {translate("update_password")}
                </Button>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {translate("devices")}
                </Typography>
                <Button
                  variant="outlined"
                  sx={buttonPrimaryStyles}
                  onClick={() => setView("devices")}
                >
                  {translate("manage_devices")}
                </Button>
              </Box>

              <Divider />

              <Button
                variant="contained"
                color="error"
                onClick={onLogout}
                sx={{ mt: 1 }}
              >
                {translate("sign_out")}
              </Button>
            </>
          )}

          {view === "password" && (
            <PasswordSettings onBack={() => setView("main")} user={user} />
          )}

          {view === "devices" && (
            <DeviceSettings
              onBack={() => setView("main")}
              user={user}
              onLogout={onLogout} 
            />
          )}
        </Box>
      </Modal>
    </>
  );
}
